module.exports = __webpack_public_path__ + "img/trash-full.42df0505.png";